import {
  rfGoFactor,
  rfPainRelief,
  rfZFactor,
  rfThinkFactor,
  rfZenFactor,
  antioxidantsBottle,
  fullSpectrumBottle,
  immuneFactorsBottle,
  nacBottle,
  berberineBottle,
  vitaminBComplexBottle,
  redYeastRiceBottle,
  vesselProtectionBottle,
  vitaminD3K25000Bottle,
  vitaminD3K22000Bottle,
} from '../../../../src/images';
import { productsKeyConstants } from '../../../../config';
import { productMappedCategory } from '../../../../config/products';

export const showcaseProducts = {
  REL: {
    title: 'Relief Factor',
    segment: productMappedCategory.REL,
    description: 'You Deserve a Pain-Free Life',
    image: rfPainRelief,
    packet: true,
    url: '/products/relief-factor',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
    rating: productsKeyConstants.RF_RELIEF_FACTOR_QS,
  },
  TNK: {
    title: 'Think Factor',
    segment: productMappedCategory.TNK,
    description: 'Boost Memory and Cognition',
    image: rfThinkFactor,
    packet: false,
    url: '/products/think-factor',
    reviewUrl: '/products/think-factor#review',
    price: '$37.95',
    rating: productsKeyConstants.RF_THINK_FACTOR,
  },
  CLM: {
    title: 'Zen Factor',
    segment: productMappedCategory.ZEN,
    description: 'Find Your Zen. Change Your Life.',
    image: rfZenFactor,
    packet: false,
    url: '/products/zen-factor',
    price: '$21.95',
  },

  ENR: {
    title: 'Go Factor',
    segment: productMappedCategory.GOF,
    description: 'Smooth, Convenient Energy.',
    image: rfGoFactor,
    packet: false,
    url: '/products/go-factor',
    price: '$29.95',
  },
  SLP: {
    title: 'Z Factor',
    segment: productMappedCategory.ZFA,
    description: "A Good Night's Sleep Makes a Great Day.",
    image: rfZFactor,
    packet: false,
    url: '/products/z-factor',
    reviewUrl: '/products/z-factor#review',
    price: '$19.95',
    rating: productsKeyConstants.RF_Z_FACTOR,
  },
  ACB: {
    title: 'Antioxidants with Vitamin C & Bioflavonoids',
    segment: productMappedCategory.DAE,
    // description: 'You Deserve a Pain-Free Life',
    image: antioxidantsBottle,
    packet: true,
    url: '/products/antioxidants',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
  },
  FSE: {
    title: 'Full Spectrum E',
    segment: productMappedCategory.DAE,
    // description: 'You Deserve a Pain-Free Life',
    image: fullSpectrumBottle,
    packet: true,
    url: '/products/full-spectrum-e',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
  },
  IMF: {
    title: 'Immune Factors',
    segment: productMappedCategory.DAE,
    // description: 'You Deserve a Pain-Free Life',
    image: immuneFactorsBottle,
    packet: true,
    url: '/products/immune-factors',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
  },
  NAC: {
    title: 'NAC N-Acetyl L-Cysteine',
    segment: productMappedCategory.DAE,
    // description: 'You Deserve a Pain-Free Life',
    image: nacBottle,
    packet: true,
    url: '/products/nac',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
  },
  BER: {
    title: 'Berberine',
    segment: productMappedCategory.DAE,
    // description: 'You Deserve a Pain-Free Life',
    image: berberineBottle,
    packet: true,
    url: '/products/berberine',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
  },
  VBC: {
    title: 'Vitamin B Complex',
    segment: productMappedCategory.DAE,
    // description: 'You Deserve a Pain-Free Life',
    image: vitaminBComplexBottle,
    packet: true,
    url: '/products/vitamin-b-complex',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
  },
  RYC: {
    title: 'Red Yeast Rice with CoQ10',
    segment: productMappedCategory.DAE,
    // description: 'You Deserve a Pain-Free Life',
    image: redYeastRiceBottle,
    packet: true,
    url: '/products/red-yeast-rice',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
  },
  VEP: {
    title: 'Vessel Protection',
    segment: productMappedCategory.DAE,
    // description: 'You Deserve a Pain-Free Life',
    image: vesselProtectionBottle,
    packet: true,
    url: '/products/vessel-protection',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
  },
  DK2: {
    title: 'Vitamin D3 and K-2 2000 IU',
    segment: productMappedCategory.DAE,
    // description: 'You Deserve a Pain-Free Life',
    image: vitaminD3K22000Bottle,
    packet: true,
    url: '/products/vitamin-d-k',
    variantKey: 'DK2',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
  },
  DK5: {
    title: 'Vitamin D3 and K-2 5000 IU',
    segment: productMappedCategory.DAE,
    // description: 'You Deserve a Pain-Free Life',
    image: vitaminD3K25000Bottle,
    packet: true,
    url: '/products/vitamin-d-k',
    variantKey: 'DK5',
    reviewUrl: '/products/relief-factor#review',
    price: '$19.95',
  },
};
